import { render, staticRenderFns } from "./dependentsPopup.vue?vue&type=template&id=56e88d2a&scoped=true"
import script from "./dependentsPopup.vue?vue&type=script&lang=js"
export * from "./dependentsPopup.vue?vue&type=script&lang=js"
import style0 from "./dependentsPopup.vue?vue&type=style&index=0&id=56e88d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e88d2a",
  null
  
)

export default component.exports